<ion-fab-button
  *ngFor="let day of days; let i = index"
  [ngClass]="!!selectedDays.includes(i) ? 'selected' : 'unselected'"
  (click)="toggleDay(i)"
>
  {{day}}
</ion-fab-button>

